import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect', {
        url: '/saaspassConnect',
        component: 'companySaaspassConnect',
        resolve: {connectApplications},
    });
}

/** @ngInject */
function connectApplications(companyId, SaaspassConnectService) {
    return SaaspassConnectService.saaspassConnects.query({id: companyId}).$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/saaspass-connect.state.js